'use client';

import { c as _c } from "react/compiler-runtime";
import type { JSX, ReactElement } from 'react';
import { useOnboardingState } from '#lib/onboarding-provider';
import type { SaveOnboardingResults } from '#lib/results/onboarding-results';
import type { OnboardingStep } from '#lib/steps/step';
import { DigitalSetupStep } from './steps/digital-setup-step';
import { HostedAudienceStep } from './steps/hosted-audience-step';
import { HostedTierStep } from './steps/hosted-tier-step';
import { OutcomeStep } from './steps/outcome-step';
import { PriorityStep } from './steps/priority-step';
import { ProvisioningStep } from './steps/provisioning-step';
import { RecommendationStep } from './steps/recommendation-step';
import { SummaryStep } from './steps/summary-step';
type OnboardingRouterProps = {
  /**
   * The host's persist action, threaded down to the provisioning step. It lives
   * in the host (not this package) so it can resolve the signed-in company from
   * web's auth server-side — see `SaveOnboardingResults`.
   */
  saveResults: SaveOnboardingResults;
};
export const OnboardingRouter = t0 => {
  const $ = _c(9);
  const {
    saveResults
  } = t0;
  const {
    onboardingState: t1
  } = useOnboardingState();
  const {
    currentStep
  } = t1;
  let t2;
  let t3;
  let t4;
  let t5;
  let t6;
  let t7;
  let t8;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <OutcomeStep />;
    t3 = <DigitalSetupStep />;
    t4 = <PriorityStep />;
    t5 = <RecommendationStep />;
    t6 = <HostedAudienceStep />;
    t7 = <HostedTierStep />;
    t8 = <SummaryStep />;
    $[0] = t2;
    $[1] = t3;
    $[2] = t4;
    $[3] = t5;
    $[4] = t6;
    $[5] = t7;
    $[6] = t8;
  } else {
    t2 = $[0];
    t3 = $[1];
    t4 = $[2];
    t5 = $[3];
    t6 = $[4];
    t7 = $[5];
    t8 = $[6];
  }
  let t9;
  if ($[7] !== saveResults) {
    t9 = {
      outcome: t2,
      "digital-setup": t3,
      priority: t4,
      recommendation: t5,
      "hosted-audience": t6,
      "hosted-tier": t7,
      summary: t8,
      provisioning: <ProvisioningStep saveResults={saveResults} />
    };
    $[7] = saveResults;
    $[8] = t9;
  } else {
    t9 = $[8];
  }
  const onboardingStepComponent = t9;
  return onboardingStepComponent[currentStep];
};